import { useCallback, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

import { useBillingProvider } from 'lib/hooks/queries/practice/useBillingProvider';

import CreateUpdateBillingProvider from 'components/admin/pages/Practices/Billing/components/CreateUpdateBillingProvider';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import EmptyBillingProviders from './components/EmptyBillingProviders';
import MotionActions from './components/MotionActions';
import { DEFAULT_COLUMNS } from './lib/helpers';

const BillingTable = ({
  updateConfigs,
  setHeaderButtonProps,
  onPrev,
  mutateOrchestratorData,
  orchestratorLoading
}) => {
  useEffect(() => {
    updateConfigs({
      message: 'After adding billing providers you can submit the data.',
      goBackHandler: onPrev,
      actions: [
        {
          text: 'Continue',
          onClick: async () => mutateOrchestratorData(),
          isDisabled: orchestratorLoading
        }
      ]
    });
  }, [orchestratorLoading]);

  const { practice } = useOutletContext();

  const renderEmptyState = useCallback(() => <EmptyBillingProviders />, []);
  if (!practice) {
    return null;
  }

  return (
    <div className="mb-4 flex flex-1 flex-col">
      <AgTablePage
        title="Billing Providers"
        useData={useBillingProvider}
        defaultFilters={[]}
        defaultColumns={DEFAULT_COLUMNS}
        ModalComponent={CreateUpdateBillingProvider}
        name="billInfo"
        noRowsOverlayComponent={renderEmptyState}
        actions={(props) => (
          <MotionActions {...props} setMotionHeaderButtonProps={setHeaderButtonProps} />
        )}
        newButtonText="Billing Provider"
        queryParams={{ practiceId: practice?.id }}
        className="overflow-y-auto rounded-2xl border border-solid border-neutral-200"
        noHeader
        autoHeight
        setMotionHeaderButtonProps={setHeaderButtonProps}
      />
    </div>
  );
};

export default BillingTable;
